import React from 'react'
import { Tag } from 'antd'
import PropTypes from 'prop-types'

const Enabled = ({ enabled }) => {
  return (
    <span>
      {enabled ? <Tag color='#87d068'>Enabled</Tag> : <Tag color='#f50'>Disabled</Tag>}
    </span>
  )
}

Enabled.propTypes = {
  enabled: PropTypes.bool
}

export default Enabled
